module.exports = __webpack_public_path__ + "img/services_web_apps_xs.51f2958a.png";